module.exports = __webpack_public_path__ + "img/DecisionCardBG.72a352bd.jpg";